export const transformActionFilters = (actionFilters) => {
  if (!actionFilters) return {};
  let readFound = actionFilters.some((a) => a === 'read');
  let unreadFound = actionFilters.some((a) => a === 'unread');
  let followedFound = actionFilters.some((a) => a === 'followed');
  let unfollowedFound = actionFilters.some((a) => a === 'unfollowed');
  let sharedFound = actionFilters.some((a) => a === 'shared');
  let unsharedFound = actionFilters.some((a) => a === 'unshared');
  return {
    read: readFound === unreadFound ? undefined : readFound,
    followed: followedFound === unfollowedFound ? undefined : followedFound,
    shared: sharedFound === unsharedFound ? undefined : sharedFound,
  };
};

export const transformReadFiltersToArray = (read) => {
  if (read === null) return [];
  return read ? ['read'] : ['unread'];
};

export const transformSharedFiltersToArray = (shared) => {
  if (shared === null) return [];
  return shared ? ['shared'] : ['unshared'];
};

export const transformFollowedFiltersToArray = (followed) => {
  if (followed === null) return [];
  return followed ? ['followed'] : ['unfollowed'];
};
